import PropTypes from 'prop-types'

const KeyHintLetterPropType = PropTypes.oneOf([
  'm', 'n', 'r', 's', 't', 'x', 'z'
])

export default KeyHintLetterPropType
